export const MAX_UPLOAD_FILE_SIZE = 50 * 1024 * 1024;
export const ALLOW_FILE_TYPES = [
  '.PDF',
  '.DOC',
  '.DOCX',
  '.XLS',
  '.TXT',
  '.JPG',
  '.PNG',
  '.GIF',
  '.JPEG',
  '.WEBP'
];

export const MAX_MESSAGE_SKELETON_LOADING_NUMBER: number = 5;
export const MAX_CONVERSATION_MESSAGES_LOADING_LIMIT: number = 16;
